export const handleDecimals = (value: string) => {
  const [wholeUnits, decimals] = value.split('.');

  if (!decimals) {
    return value;
  }

  return `${wholeUnits}.${decimals.slice(0, 8)}`; // only include up to 8 decimals to prevent rounding errors
};
